import React from "react";

const FirstPageIcon = () => {
    return <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.14453 11.8535L2.29102 6L8.14453 0.146484L8.85352 0.855469L3.70898 6L8.85352 11.1445L8.14453 11.8535Z" fill="#191919"/>
        <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="12" stroke="black"/>
        </svg>
}

export default FirstPageIcon